// MODULES
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '@components/components.module';
import { AppRoutingModule } from '../app-routing.module';

// PAGES
import { HomeComponent } from '@pages/home/home.component';
import { BrandsComponent } from '@pages/brands/brands.component';
import { ProductsDetailComponent } from '@pages/products-detail/products-detail.component';
import { NotFoundComponent } from '@pages/not-found/not-found.component';

@NgModule({
  declarations: [
    HomeComponent,
    BrandsComponent,
    ProductsDetailComponent,
    NotFoundComponent,
  ],
  imports: [CommonModule, ComponentsModule, AppRoutingModule],
  exports: [
    HomeComponent,
    BrandsComponent,
    ProductsDetailComponent,
    NotFoundComponent,
  ],
})
export class PagesModule { }
